import { useRef } from "react";
import { Link } from "react-router-dom";
import { ChevronLeft, ChevronRight, ArrowRight } from "lucide-react";

export function CarouselRow({ eyebrow, title, to, linkLabel = "Ver todo", testid, children }) {
  const ref = useRef(null);
  const scroll = (dir) => {
    const el = ref.current;
    if (!el) return;
    el.scrollBy({ left: dir * el.clientWidth * 0.85, behavior: "smooth" });
  };
  return (
    <section className="section-pad !py-12" data-testid={testid}>
      <div className="mx-auto max-w-[1400px]">
        <div className="flex items-end justify-between mb-6 gap-4">
          <div>
            {eyebrow && <p className="eyebrow mb-2">{eyebrow}</p>}
            <h2 className="display display-3">{title}</h2>
          </div>
          <div className="flex items-center gap-2 flex-shrink-0">
            {to && (
              <Link to={to} className="btn-ghost hidden md:inline-flex" data-testid={`${testid}-all`}>
                {linkLabel} <ArrowRight size={16} />
              </Link>
            )}
            <div className="hidden md:flex gap-1.5">
              <button onClick={() => scroll(-1)} className="h-9 w-9 rounded-full border border-black/15 flex items-center justify-center hover:bg-[#2A00D9] hover:text-white hover:border-[#2A00D9] transition-colors" aria-label="Anterior" data-testid={`${testid}-prev`}>
                <ChevronLeft size={18} />
              </button>
              <button onClick={() => scroll(1)} className="h-9 w-9 rounded-full border border-black/15 flex items-center justify-center hover:bg-[#2A00D9] hover:text-white hover:border-[#2A00D9] transition-colors" aria-label="Siguiente" data-testid={`${testid}-next`}>
                <ChevronRight size={18} />
              </button>
            </div>
          </div>
        </div>
        <div ref={ref} className="flex gap-5 overflow-x-auto no-scrollbar snap-x snap-mandatory scroll-smooth pb-3 -mx-1 px-1">
          {children}
        </div>
      </div>
    </section>
  );
}
